import React from "react";
import { ReactComponent as InfoIcon } from "assets/icons/info.svg";
import { ReactComponent as CalculatorIcon } from "assets/icons/calculator_fill.svg";
import { Tooltip as ReactTooltip } from "react-tooltip";
import useSearchFilter from "hooks/useSearchFilter";
import HousePriceCalculatorDialog from "components/Dialog/HousePriceCalculatorDialog";

const HiddenCostInfoBanner = () => {
  const { toggleHousePriceCalculatorDialog } = useSearchFilter();
  return (
    <div className="bg-white h-[102px] border-[1px] border-[#E2E4E9] w-full rounded-[15px] flex items-center justify-between pl-5 pr-[15px] sm:pr-[26px]">
      <div className="flex items-center space-x-[10px] sm:space-x-[15px] ">
        <div className="bg-[#E8F6FF] min-w-[52px] h-[52px] rounded-full flex items-center justify-center">
          <CalculatorIcon />
        </div>
        <h1 className="text-black max-w-[341px] text-[16px] md:text-[22px] font-semibold leading-[19.36px] md:leading-[30px] line-clamp-4">
          Scopri il<span className="text-primary"> reale </span>prezzo di una
          casa calcolando i<span className="text-primary"> costi nascosti</span>
        </h1>
      </div>
      <div className="flex items-center ">
        <button
          onClick={() =>
            toggleHousePriceCalculatorDialog("dashboardCalculator")
          }
          className="w-[99px] mr-[17px] h-[35px] border-[1px] border-primary rounded-[8px] text-center text-primary text-[12px] font-medium"
        >
          Calcola
        </button>
        <span
          className="cursor-pointer"
          data-tooltip-id="hidden_cost_info_tooltip"
          data-tooltip-content="Quando si acquista una proprietà ci sono molti costi nascosti, tasse, specialisti da chiamare e tanti altri, con HouseScan puoi calcolare tutti questi valori nascosti"
        >
          <InfoIcon className="hidden sm:block" />
        </span>
        {/* Info Tooltip  */}
        <ReactTooltip
          id="hidden_cost_info_tooltip"
          place="top"
          positionStrategy="fixed"
          className="!max-w-64 !z-10 !text-sm !text-gray-500 !bg-white border !border-gray-200 !rounded-lg !shadow-xs"
        />
      </div>
      <HousePriceCalculatorDialog id="dashboardCalculator" />
    </div>
  );
};

export default HiddenCostInfoBanner;
